<template>
	<v-container
		fluid
	>
		<v-row>
			<v-col>
				<pricing-parameter-table
					ref="pricingTable"
					verbose
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<pricing-parameter-exclusions />
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<pricing-parameter-premium-comparison />
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<pricing-parameter-sigma-threshold />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>

/**
 * A page to allow users to alter the parameters of the premiums calculations
 */
export default {
	name: 'ModelParameters',
};
</script>
